import "./Tabs.css";

import { Link, Outlet, useLocation } from "react-router-dom";

import { UserType } from "../../../constants";
import { TabElement, TabsList } from "../../../models";
import { TabNotificationIndicator } from "./components";

interface TabsProps {
  tabsList: TabsList;
  size?: "medium" | "fullWidth";
  variant?: "default" | "secondary" | "tertiary";
  className?: string;
  currentUserType?: UserType;
}

export const Tabs = ({
  size = "medium",
  variant = "default",
  tabsList,
  className = "",
  currentUserType,
}: TabsProps): JSX.Element => {
  const location = useLocation();
  const tabElement = (tab: TabElement): JSX.Element => {
    return tab.isDisabled ? (
      <div
        key={tab.label}
        className={`body2 TabElement TabElement_${variant} ${size} TabElement_${currentUserType}${
          location.pathname.includes(tab.route.split("?")[0]) ? " TabElement_active" : ""
        }`}
      >
        {tab.notify && <TabNotificationIndicator />}
        {tab.label}
      </div>
    ) : (
      <Link
        key={tab.label}
        to={tab.route}
        state={tab.state}
        onClick={() => {
          // Required in order to not trigger the effect in the `useScrollToTop` custom hook
          window.isTab = true;
        }}
        className={`body2 TabElement TabElement_${variant} TabElement_${size} TabElement_${currentUserType}${
          location.pathname.includes(tab.route.split("?")[0]) ? " TabElement_active" : ""
        }`}
      >
        {tab.notify && <TabNotificationIndicator />}
        {tab.label}
      </Link>
    );
  };

  return (
    <div>
      <nav className={`Tabs Tabs_${variant}`}>{tabsList.map((tab) => tabElement(tab))}</nav>
      <div className={`TabsContent TabsContent_${variant} TabsContent_${currentUserType} ${className}`}>
        <Outlet />
      </div>
    </div>
  );
};
